import { render, staticRenderFns } from "./IconWidgetPopup.vue?vue&type=template&id=004b6bf2&"
import script from "./IconWidgetPopup.vue?vue&type=script&lang=js&"
export * from "./IconWidgetPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('004b6bf2')) {
      api.createRecord('004b6bf2', component.options)
    } else {
      api.reload('004b6bf2', component.options)
    }
    module.hot.accept("./IconWidgetPopup.vue?vue&type=template&id=004b6bf2&", function () {
      api.rerender('004b6bf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconWidgetPopup.vue"
export default component.exports